<template>
<div class="field is-grouped is-grouped-multiline">
  <div class="control is-size-5">
    Tags:
  </div>
  <div v-for="tag in tags" :key="tag.value" class="control">
    <div class="tags has-addons is-clickable" @click="$emit('tag-click', { tag: tag.value })">
      <span class="tag is-left">{{ tag.value }}</span>
      <span class="tag is-right">{{ tag.count }}</span>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ValueCountTags',
  props: {
    endpoint: {
      type: String,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
    asset: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      tags: null,
    };
  },
  watch: {
    filter() {
      this.updateTags();
    },
  },
  async mounted() {
    this.updateTags();
  },
  methods: {
    async updateTags() {
      this.tags = await this.$store.dispatch(this.endpoint, {
        uuid: this.asset ? this.asset.uuid : null,
        since: this.filter.since,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.is-right, .is-left {
  color: whitesmoke;
  background-color: $main-background;
}

.is-right {
    opacity: .8;
}

</style>
